"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { wrapper } from './styles.js';
import { ThemeProvider } from 'styled-components';
import { IconCalendarUI } from '../icons/ui_general/IconCalendarUI.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { InputField } from '../InputField/InputField.web.js';
import { inPixels, px2rem } from '../utils/helpers/style.js';

var _excluded = ["className", "style", "errorMessage", "error", "label", "name", "value", "disabled", "mode", "dateFormat", "placeholder", "locale", "borderStyle", "labelStyle", "color", "size"];
var DatePickerLazy = /*#__PURE__*/React.lazy(function () {
  return import('./DatePickerLazy.web.js');
});
var defaultPlaceholder = {
  date: 'dd.mm.yyyy',
  month: 'mm/yyyy',
  year: 'yyyy',
  week: 'ww'
};
var DatePicker = function DatePicker(_ref) {
  var className = _ref.className,
    style = _ref.style,
    errorMessage = _ref.errorMessage,
    error = _ref.error,
    label = _ref.label,
    name = _ref.name,
    value = _ref.value,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === undefined ? false : _ref$disabled,
    _ref$mode = _ref.mode,
    mode = _ref$mode === undefined ? 'date' : _ref$mode,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === undefined ? 'dd.MM.yyyy' : _ref$dateFormat,
    placeholderProp = _ref.placeholder,
    _ref$locale = _ref.locale,
    locale = _ref$locale === undefined ? 'fi' : _ref$locale,
    borderStyle = _ref.borderStyle,
    _ref$labelStyle = _ref.labelStyle,
    labelStyle = _ref$labelStyle === undefined ? 'floating' : _ref$labelStyle,
    colorProp = _ref.color,
    sizeProp = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var color = colorProp || theme.inputField.web.color;
  var size = sizeProp !== null && sizeProp !== undefined ? sizeProp : theme.preferredComponentSize;
  var placeholder = placeholderProp || defaultPlaceholder[mode];
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(wrapper, {
    "data-testid": "elemental-DatePicker",
    className: className,
    $color: color,
    style: style
  }, /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: props.customInput || /*#__PURE__*/React.createElement(InputField, {
      color: color,
      errorMessage: errorMessage,
      error: error,
      label: label,
      name: name,
      value: value,
      size: size,
      disabled: disabled,
      placeholder: placeholder,
      rightIcon: /*#__PURE__*/React.createElement(IconCalendarUI, {
        role: "presentation",
        size: size === 'l' ? inPixels(32) : undefined,
        marginTop: size === 'l' ? px2rem(-4) : undefined
      }),
      borderStyle: borderStyle || theme.inputField.web.borderStyle,
      labelStyle: labelStyle
    })
  }, /*#__PURE__*/React.createElement(DatePickerLazy, _extends({
    errorMessage: errorMessage,
    error: error,
    label: label,
    name: name,
    value: value,
    disabled: disabled,
    dateFormat: dateFormat,
    locale: locale,
    color: color,
    borderStyle: borderStyle || theme.inputField.web.borderStyle,
    size: size,
    placeholder: placeholder,
    mode: mode
  }, props)))));
};

export { DatePicker };
